import { Box, Grid } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';
import BotelManagement from '../../components/admin/BotelManagement';
import GuestManagement from '../../components/admin/GuestManagement';
import HostPartnerManagement from '../../components/admin/HostPartnerManagement';
import InfoIcon from '@mui/icons-material/Info';

const GuestHostManagementPage = () => {
  return (
    <AdminLayout>
      <Box sx={{ flexGrow: 1, p: { xs: 1, sm: 2, md: 3 }, background: '#151A23', minHeight: '100vh', color: '#fff', marginTop: 2 }}>
        <Grid container spacing={3}>
          <Grid size={{xs: 12, md: 6}}>
            <GuestManagement />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <HostPartnerManagement />
          </Grid>
          <Grid size={{xs: 12}}>
            <BotelManagement />
          </Grid>
        </Grid>
      </Box>
    </AdminLayout>
  );
};

export default GuestHostManagementPage; 